module.exports = __webpack_public_path__ + "static/media/score.e1f517e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/score.svg
// module id = 788
// module chunks = 0